import { Button } from "@omni/ui/components/Button/button.component";
import { PropsWithChildren, SyntheticEvent } from "react";

import { useCallToActionContext } from "@/components/General/CallToAction/callToAction.context";

type AddToCartButtonComponentProps = PropsWithChildren<{
    onClick: (event: SyntheticEvent<HTMLButtonElement>) => void;
}>;

const AddToCartButtonComponent = ({
    onClick,
    children
}: AddToCartButtonComponentProps) => {
    const { trackingProperties, styleProperties } = useCallToActionContext();

    return (
        <Button
            type={"submit"}
            {...styleProperties}
            dataAttributes={trackingProperties.click}
            onClick={onClick}
        >
            {children}
        </Button>
    );
};

export { AddToCartButtonComponent };
